import PropTypes from "prop-types";
import React from "react";
import withRouter from "../Common/withRouter";

// Layout Related Components
import Header from "./Header";
import Sidebar from "./Sidebar";

//redux

import useRoutes from "../../constants/routesData";

const Layout = (props) => {
  const route = useRoutes();

  const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);

  const routeIndex = route.findIndex((e) =>
    window.location.pathname.includes(e.path)
  );
  const activeRouteIndex = route.findIndex(
    (e) => e.path === window.location.pathname
  );
  return (
    <React.Fragment>
      <div id="layout-wrapper">
        <Header activeRoute={route[activeRouteIndex]?.name} />

        <Sidebar
          theme="light"
          type="light"
          isMobile={isMobile}
          route={route}
          activeRoute={route[routeIndex]?.name}
        />
        <div className="main-content">{props.children}</div>
      </div>
    </React.Fragment>
  );
};

Layout.propTypes = {
  changeLayoutWidth: PropTypes.func,
  changeSidebarTheme: PropTypes.func,
  changeSidebarThemeImage: PropTypes.func,
  changeSidebarType: PropTypes.func,
  changeTopbarTheme: PropTypes.func,
  children: PropTypes.any,
  isPreloader: PropTypes.any,
  layoutWidth: PropTypes.any,
  leftSideBarTheme: PropTypes.any,
  leftSideBarThemeImage: PropTypes.any,
  leftSideBarType: PropTypes.any,
  location: PropTypes.object,
  showRightSidebar: PropTypes.any,
  topbarTheme: PropTypes.any,
};

export default withRouter(Layout);
